export default __webpack_public_path__ + "static/app-store-badge-2859094608c869a0dcff6691796e9863.png";